export const APPLICATION_NAMES = {
  SCHOOL_APP: 'SchoolApp',
  TSM: 'TSM',
  EDUROOMS: 'EduRooms',
  THRILLSHARE: 'Thrillshare',
  SCHOOL_WEBSITE: 'SchoolWebsite',
  THIRD_PARTY_APP: 'ThirdPartyApp',
  ATTENDANCE_PRO: 'AttendancePro',
} as const;

export type ApplicationName = (typeof APPLICATION_NAMES)[keyof typeof APPLICATION_NAMES];
